/* eslint-disable react/no-unescaped-entities */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styles from './terms.module.scss';
import { getOidcToken } from '../../env-vars';
import AuthService from '../../services/AuthService';
import { setUser } from '../../store/shared/userSlice';
import MobileNav from '../Navigation/MobileNav';

export default function TermsPage() {
  const authService = new AuthService();
  let userSession = localStorage.getItem(getOidcToken());

  if (!userSession) {
    const key = localStorage.key(
      localStorage.length > 0 ? localStorage.length - 1 : 0,
    );
    userSession = localStorage.getItem(key);
  }

  if (userSession) {
    try {
      const objToken = JSON.parse(userSession);
      if (
        objToken.expires_at &&
        objToken.expires_at <= new Date().getTime() / 1000
      ) {
        userSession = null;
      }
    } catch (e) {}
  }

  const dispatch = useDispatch();

  useEffect(() => {
    if (!userSession) {
      dispatch(setUser({}));
      return;
    }

    authService.getUser().then((res) => {
      if (res) {
        dispatch(setUser({ ...res }));
      }
    });
  }, [userSession]);

  return (
    <div className={styles.termsPageContainer}>
      <MobileNav items={[]} title="Partner Platform" />
      <div className="d-flex align-items-center justify-content-center">
        <div className={styles.cardContainer}>
          <div className={`${styles.header} mb-3`}>
            <div className={styles.label}>
              PMI Partner Platform Terms of Use
            </div>
            <div className={styles.subLabel}>
              Revision date 16 September 2026
            </div>
            <div className={styles.subLabel}>Version 1.3.0</div>
          </div>
          <div className={styles.sections}>
            <section className="mb-4">
              <div className={`${styles.description} ${styles.subHeader}`}>
                These terms and conditions govern Company’s use of the Project
                Management Institute’s B2B Partner Platform (the “Agreement”).
                The Platform, together with all information, content, products,
                materials and services made available to Company, shall be
                collectively referred to as the services (“Services”). By using
                or otherwise accessing the Services, or any component thereof in
                any manner whatsoever, Company agrees to comply with the terms
                and conditions of this Agreement.
              </div>
            </section>
            <section className={`mb-4 `}>
              <h6 className={styles.title}>1. Definitions</h6>
              <div className={styles.listStyle}>
                <p className={styles.description}>
                  1.1 The term “Company” refers to each business organization
                  using the Platform.
                </p>
                <p className={styles.description}>
                  1.2 The terms “PMI”, “We”, and “Us” refer to Project
                  Management Institute, Inc.
                </p>
                <p className={styles.description}>
                  1.3 The term "Platform" refers to the B2B Partner Platform,
                  which is owned and operated by Project Management Institute,
                  Inc.
                </p>
                <p className={styles.description}>
                  1.4 The term “User” refers to each Company individual licensed
                  to access the Platform.
                </p>
                <p className={styles.description}>
                  1.5 The term “Company Administrator” refers to a Company’s
                  appointment of a Company Administrator employee role to manage
                  employee engagement. Within the Platform, the Company
                  Administrator may provide access to Services to eligible
                  employees, create reports for Company, and personalize User
                  screens for Company employees.
                </p>
                <p className={styles.description}>
                  1.6 The term "PMI Intellectual Property" refers to, all text,
                  graphics, images, trademarks, logos, button icons, programs,
                  software and other data, content, information and materials,
                  tangible and intangible, and all intellectual property rights
                  in and to the same which are owned by PMI or licensed to PMI
                  by third parties. This includes but is not limited to PMI
                  Content and PMI Trademarks.
                </p>
                <p className={styles.description}>
                  1.7 The term "PMI Trademark(s)" refers to all trademarks and
                  service marks of PMI, as defined by 15 U.S.C. § 1127.
                </p>
                <p className={styles.description}>
                  1.8 The term "PMI Content" refers to copyrighted content owned
                  or licensed by PMI.
                </p>
              </div>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>
                2. Use of the Services means any actual or attempted access or
                use of the Services, including, without limitation, any
                transmission, exchange of information or communication
                associated with the Services
              </h6>
              <p className={styles.description}>
                This Agreement, together with other terms of use on other
                PMI-owned or controlled web sites, and any other policies, rules
                and provisions which are described, linked or otherwise referred
                to on this Platform, are each included by reference into this
                Agreement. This includes, without limitation, the PMI Privacy
                Policy. All such terms constitute the entire agreement between
                Company and PMI, superseding any and all prior or inconsistent
                understandings, representations or agreements regarding the
                Services
              </p>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>
                3. PMI reserves the right to modify this Agreement at any time
                and will post a notice of such changes.
              </h6>
              <p className={styles.description}>
                The changes become effective immediately upon posting (the
                "Effective Date"). If any change to the Agreement is not
                acceptable to Company, Company must stop using the Services.
                Company use of the Services after the Effective Date shall
                constitute Company’s acceptance of such changes. Unless PMI
                communicates that different terms apply, any new Services added
                to the Platform shall be governed by the terms of this
                Agreement. Company and Users must also comply with any
                additional terms which apply to third-party content, material,
                information, software or other services
              </p>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>
                4. Ownership and Intellectual Property Rights of the Platform
                remain with PMI
              </h6>
              <p className={styles.description}>
                This Platform is protected by United States copyright and
                trademark laws and international treaty provisions. Company
                agrees to prevent any unauthorized use of the Platform. Except
                as expressly provided herein, PMI does not grant any express or
                implied intellectual property right to Company under its
                patents, copyrights, trademarks, or trade secret information.
              </p>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>5. Trademarks</h6>
              <p className={styles.description}>
                The PMI Trademarks ("Marks") appearing on this Platform may not
                be used in any advertising or publicity, or otherwise to
                indicate PMI's sponsorship of or affiliation with any product or
                service, without PMI's prior express written permission. Company
                is prohibited from using PMI Marks or any names, marks, or other
                materials in a manner that is likely to cause confusion or
                dilute or damage the reputation or image of PMI. Company agrees
                it will not alter any PMI Mark in any manner to make it appear
                that PMI is endorsing, sponsoring, authorizing or affiliated
                with Company or any third party, except as expressly permitted
                in writing by PMI. Additionally, Company agrees to be bound by
                and to follow the terms of PMI's Trademark Usage Guidelines
                located{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.pmi.org/-/media/pmi/documents/public/pdf/about/press-media/trademark-usage-guidelines-new.pdf?rev=a5341ed1da884ada96b6567c8b15c2e3"
                >
                  <u>here</u>.
                </a>
              </p>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>6. Limited License</h6>
              <p className={styles.description}>
                Upon execution of this Agreement, Users are entitled to use the
                Platform solely for the purpose of obtaining access to Services.
                Users are the sole recipients of the Services and Company is not
                entitled to access to or rights in the Services. Neither Company
                nor its employees will otherwise use, distribute, assign,
                transfer, sublicense or sell such Services. Company
                Administrator(s) may perform additional Services in the Platform
                for the benefit of Company, such as providing reports. Neither
                Company nor any User may sell, license, or transfer the
                Platform, or reproductions of the Platform to other parties in
                any way.
              </p>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>7. Indemnity</h6>
              <p className={styles.description}>
                Company agrees that PMI shall have no liability whatsoever to
                Company, its affiliates, employees, representatives, agents,
                contractors or assigns for any cost or expense arising out of or
                resulting from the fulfillment of PMI’s obligations hereunder.
                Company shall indemnify, defend and hold PMI harmless from and
                against any claim, expense, loss, injury, or damage to persons
                or property, including without limitation, reasonable attorneys’
                fees caused by or resulting from any improper or unlawful
                receipt or use of the Services or any negligent or willful act
                or omission of Company, its affiliates, employees,
                representatives, agents or contractors.
              </p>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>8. Limitation of Liability</h6>
              <p className={styles.description}>
                The platform is provided “as is” without any express or implied
                warranty of any kind including warranties of merchantability or
                fitness for any particular purpose. In no event shall pmi be
                liable for any damages whatsoever (including, without
                limitation, damages for loss of profits, business interruption,
                loss of information) arising out of the use of or inability to
                use the platform, even if pmi has been advised of the
                possibility of such damages.
              </p>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>9. Confidentiality</h6>
              <p className={styles.description}>
                This Platform is available to invited organizations and their
                respective Users. The Company shall not communicate information
                concerning the Platform to any third party without the prior
                written approval of PMI. The Company will maintain the
                confidentiality of the Platform with at least the same degree of
                care that Company would use to protect Company’s own
                confidential and proprietary information, but not less than a
                reasonable degree of care under the circumstances. The Company
                will not be liable for the disclosure of any confidential
                information which is: (a) in the public domain other than by an
                unauthorized breach by any third party; (b) rightfully received
                from a third party without any obligation of confidentiality;
                (c) rightfully known to User without any limitation on use or
                disclosure prior to its receipt from PMI; or (d) generally made
                available to third parties by PMI without restriction on
                disclosure. Company shall communicate this confidentiality
                clause to all Company users.
              </p>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>10. Support</h6>
              <p className={styles.description}>
                PMI will provide Company with commercially reasonable
                maintenance, technical and other support for the Platform.
                Company agrees to abide by all maintenance and support rules and
                policies that PMI provides in order to receive such support.
              </p>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>11. Feedback</h6>
              <p className={styles.description}>
                Users may provide suggestions, modifications, improvements, or
                ideas (“Feedback”) to improve the Platform user experience. All
                User Feedback submitted by User to PMI shall become the
                exclusive intellectual property of PMI upon submission of
                Feedback to PMI.
              </p>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>12. Privacy/PMI.org Policy</h6>
              <p className={styles.description}>
                PMI’s privacy policy (available at{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.pmi.org/privacy"
                >
                  <u>www.pmi.org/privacy</u>
                </a>
                ) applies to Users. Company and PMI represent and warrant that
                they maintain appropriate administrative, physical and technical
                safeguards to protect the confidentiality, integrity and
                security of their customers’ data, including without limitation
                personally identifiable information. The Parties further
                represent and warrant that they are in compliance with the
                requirements of all applicable data protection laws in
                connection with their provision of Goods or Services. Where
                applicable, the Parties are separate Controllers, and the
                attached Appendix A, Controller to Controller Standard
                Contractual Clauses, are incorporated herein. Company shall be
                solely responsible for obtaining any and all required consents
                prior to transferring Personal Data to PMI.
              </p>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>13. Fees and Payment</h6>
              <p className={styles.description}>
                There are no license fees for use of the Platform under this
                Agreement; however, organizations may incur costs for Services
                obtained via the platform.
              </p>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>14. Severability/Waiver</h6>
              <p className={styles.description}>
                The waiver of a breach of any term of this Agreement shall in no
                way be construed as a waiver of any term or other breach hereof.
                If any provision of this Agreement is held by a court of
                competent jurisdiction to be invalid or unenforceable, the
                remaining provisions of this Agreement shall remain in full
                force and effect.
              </p>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>15. No Assignment</h6>
              <p className={styles.description}>
                Neither party may assign or otherwise transfer any rights or
                obligations under this Agreement.
              </p>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>16. No Survival of Term</h6>
              <p className={styles.description}>
                All provisions of these terms and conditions which impose
                obligations continuing in nature shall survive the termination
                of this Agreement.
              </p>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>17. Entire Agreement</h6>
              <p className={styles.description}>
                These terms and conditions supersede all different or
                conflicting terms, oral or in writing, with respect to PMI’s
                provision of the Platform and rendering of the Services via the
                Platform. Any other different or conflicting terms and
                conditions are void and without effect.
              </p>
            </section>
            <section className="mb-4">
              <h6 className={styles.title}>18. Choice of Law and Disputes</h6>
              <p className={styles.description}>
                This Agreement shall be governed by and construed in accordance
                with the laws of the Commonwealth of Pennsylvania and without
                giving effect to the principles of conflict of law rules of any
                jurisdiction or the United Nations Convention on Contracts for
                the International Sale of Goods, the Platform of which is
                expressly excluded. Any legal action or proceeding arising under
                this Agreement will be brought exclusively in the federal or
                state courts located in Delaware County, Pennsylvania and the
                parties hereby consent to personal jurisdiction and venue
                therein.
              </p>
            </section>
          </div>
          <div className={styles.apppendixA}>
            <div className={`${styles.apppendixAHeader}`}>
              Appendix A - Standard Contractual Clauses for Personal Data
              Transfers from an EU Controller to a Controller Established in a
              Third Country (Controller-to-Controller Transfers)
            </div>
            <section className="mb-4">
              <h5 className="mb-2 text-center">SECTION I</h5>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 1</h5>
                <h6 className="mb-4">Purpose and scope</h6>
                <div className="mb-4">
                  <ul>
                    <li className="mb-4">
                      <strong>(a)</strong> The purpose of these standard
                      contractual clauses is to ensure compliance with the
                      requirements of Regulation (EU) 2016/679 of the European
                      Parliament and of the Council of 27 April 2016 on the
                      protection of natural persons with regard to the
                      processing of personal data and on the free movement of
                      such data (General Data Protection Regulation) for the
                      transfer of personal data to a third country.
                    </li>
                    <li className="mb-4">
                      <strong>(b)</strong> The Parties:
                      <ul className="ms-4 my-3">
                        <li className="mb-4">
                          <strong>(i)</strong> the natural or legal person(s),
                          public authority/ies, agency/ies or other body/ies
                          (hereinafter 'entity/ies') transferring the personal
                          data, as listed in Annex I.A (hereinafter each 'data
                          exporter'), and
                        </li>
                        <li className="mb-4">
                          <strong>(ii)</strong> the entity/ies in a third
                          country receiving the personal data from the data
                          exporter, directly or indirectly via another entity
                          also Party to these Clauses, as listed in Annex I.A
                          (hereinafter each data importer) have agreed to these
                          standard contractual clauses (hereinafter: 'Clauses').
                        </li>
                      </ul>
                    </li>
                    <li className="mb-4">
                      <strong>(c)</strong> These Clauses apply with respect to
                      the transfer of personal data as specified in Annex I.B.
                    </li>
                    <li className="mb-4">
                      <strong>(d)</strong> The Appendix to these Clauses
                      containing the Annexes referred to therein forms an
                      integral part of these Clauses.
                    </li>
                  </ul>
                </div>
              </div>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 2</h5>
                <h6 className="mb-4">
                  Effect and invariability of the Clauses
                </h6>
                <div className="mb-4">
                  <ul>
                    <li className="mb-4">
                      <strong>(a)</strong> These Clauses set out appropriate
                      safeguards, including enforceable data subject rights and
                      effective legal remedies, pursuant to Article 46(1) and
                      Article 46(2)(c) of Regulation (EU) 2016/679 and, with
                      respect to data transfers from controllers to processors
                      and/or processors to processors, standard contractual
                      clauses pursuant to Article 28(7) of Regulation (EU)
                      2016/679, provided they are not modified, except to select
                      the appropriate Module(s) or to add or update information
                      in the Appendix. This does not prevent the Parties from
                      including the standard contractual clauses laid down in
                      these Clauses in a wider contract and/or to add other
                      clauses or additional safeguards, provided that they do
                      not contradict, directly or indirectly, these Clauses or
                      prejudice the fundamental rights or freedoms of data
                      subjects.
                    </li>
                    <li className="mb-4">
                      <strong>(b)</strong> These Clauses are without prejudice
                      to obligations to which the data exporter is subject by
                      virtue of Regulation (EU) 2016/679.
                    </li>
                  </ul>
                </div>
              </div>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 3</h5>
                <h6 className="mb-4">Third-party beneficiaries</h6>
                <div className="mb-4">
                  <ul className="mb-4">
                    <li className="mb-4">
                      <strong>(a)</strong> Data subjects may invoke and enforce
                      these Clauses, as third-party beneficiaries, against the
                      data exporter and/or data importer, with the following
                      exceptions:
                      <ul className="ms-4 my-3">
                        <li className="mb-4">
                          <strong>(i)</strong> Clause 1, Clause 2, Clause 3,
                          Clause 6, Clause 7;
                        </li>
                        <li className="mb-4">
                          <strong>(ii)</strong> Clause 8 – Module One: Clause
                          8.5 (e) and Clause 8.9(b); Module Two: Clause 8.1(b),
                          8.9(a), (c), (d) and (e); Module Three: Clause 8.1(a),
                          (c) and (d) and Clause 8.9(a), (c), (d), (e), (f) and
                          (g); Module Four: Clause 8.1 (b) and Clause 8.3(b);
                        </li>
                        <li className="mb-4">
                          <strong>(iii)</strong> Clause 9 – Module Two: Clause
                          9(a), (c), (d) and (e); Module Three: Clause 9(a),
                          (c), (d) and (e);
                        </li>
                        <li className="mb-4">
                          <strong>(iv)</strong> Clause 12 – Module One: Clause
                          12(a) and (d); Modules Two and Three: Clause 12(a),
                          (d) and (f);
                        </li>
                        <li className="mb-4">
                          <strong>(v)</strong> Clause 13;
                        </li>
                        <li className="mb-4">
                          <strong>(vi)</strong> Clause 15.1(c), (d) and (e);
                        </li>
                        <li className="mb-4">
                          <strong>(vii)</strong> Clause 16(e);
                        </li>
                        <li className="mb-4">
                          <strong>(viii)</strong> Clause 18 – Modules One, Two
                          and Three: Clause 18(a) and (b); Module Four: Clause
                          18.
                        </li>
                      </ul>
                    </li>
                    <li className="mb-4">
                      <strong>(b)</strong> Paragraph (a) is without prejudice to
                      rights of data subjects under Regulation (EU) 2016/679.
                    </li>
                  </ul>
                </div>
              </div>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 4</h5>
                <h6 className="mb-4">Interpretation</h6>
                <div>
                  <ul>
                    <li className="mb-4">
                      <strong>(a)</strong> Where these Clauses use terms that
                      are defined in Regulation (EU) 2016/679, those terms shall
                      have the same meaning as in that Regulation.
                    </li>
                    <li className="mb-4">
                      <strong>(b)</strong> These Clauses shall be read and
                      interpreted in the light of the provisions of Regulation
                      (EU) 2016/679.
                    </li>
                    <li className="mb-4">
                      <strong>(c)</strong> These Clauses shall not be
                      interpreted in a way that conflicts with rights and
                      obligations provided for in Regulation (EU) 2016/679.
                    </li>
                  </ul>
                </div>
              </div>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 5</h5>
                <h6 className="mb-4">Hierarchy</h6>
                <p>
                  In the event of a contradiction between these Clauses and the
                  provisions of related agreements between the Parties, existing
                  at the time these Clauses are agreed or entered into
                  thereafter, these Clauses shall prevail.
                </p>
              </div>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 6</h5>
                <h6 className="mb-4">Description of the transfer(s)</h6>
                <p>
                  The details of the transfer(s), and in particular the
                  categories of personal data that are transferred and the
                  purpose(s) for which they are transferred, are specified in
                  Annex I.B.
                </p>
              </div>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 7</h5>
                <h6 className="mb-4">Docking clause</h6>
                <p>N/A</p>
              </div>
            </section>
            <section className="mb-4">
              <h5 className="mb-2 text-center">
                SECTION II – OBLIGATIONS OF THE PARTIES
              </h5>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 8</h5>
                <h6 className="mb-4">Data protection safeguards</h6>
                <p className="mb-4">
                  The data exporter warrants that it has used reasonable efforts
                  to determine that the data importer is able, through the
                  implementation of appropriate technical and organisational
                  measures, to satisfy its obligations under these Clauses.
                </p>
                <h6 className="mb-4">8.1 Purpose limitation</h6>
                <div className="mb-4">
                  The data importer shall process the personal data only for the
                  specific purpose(s) of the transfer, as set out in Annex I.B.
                  It may only process the personal data for another purpose:
                  <ul className="ms-4 my-3">
                    <li className="mb-4">
                      <strong>(i)</strong> where it has obtained the data
                      subject's prior consent;
                    </li>
                    <li className="mb-4">
                      <strong>(ii)</strong> where necessary for the
                      establishment, exercise or defence of legal claims in the
                      context of specific administrative, regulatory or judicial
                      proceedings; or
                    </li>
                    <li className="mb-4">
                      <strong>(iii)</strong> where necessary in order to protect
                      the vital interests of the data subject or of another
                      natural person.
                    </li>
                  </ul>
                </div>
                <h6 className="mb-4">8.2 Transparency</h6>
                <div className="mb-4">
                  <ul>
                    <li className="mb-4">
                      <strong>(a)</strong> In order to enable data subjects to
                      effectively exercise their rights pursuant to Clause 10,
                      the data importer shall inform them, either directly or
                      through the data exporter:
                      <ul className="ms-4 my-3">
                        <li className="mb-4">
                          <strong>(i)</strong> of its identity and contact
                          details;
                        </li>
                        <li className="mb-4">
                          <strong>(ii)</strong> of the categories of personal
                          data processed;
                        </li>
                        <li className="mb-4">
                          <strong>(iii)</strong> of the right to obtain a copy
                          of these Clauses;
                        </li>
                        <li className="mb-4">
                          <strong>(iv)</strong> where it intends to onward
                          transfer the personal data to any third party/ies, of
                          the recipient or categories of recipients (as
                          appropriate with a view to providing meaningful
                          information), the purpose of such onward transfer and
                          the ground therefore pursuant to Clause 8.7.
                        </li>
                      </ul>
                    </li>
                    <li className="mb-4">
                      <strong>(b)</strong> Paragraph (a) shall not apply where
                      the data subject already has the information, including
                      when such information has already been provided by the
                      data exporter, or providing the information proves
                      impossible or would involve a disproportionate effort for
                      the data importer. In the latter case, the data importer
                      shall, to the extent possible, make the information
                      publicly available.
                    </li>
                    <li className="mb-4">
                      <strong>(c)</strong> On request, the Parties shall make a
                      copy of these Clauses, including the Appendix as completed
                      by them, available to the data subject free of charge. To
                      the extent necessary to protect business secrets or other
                      confidential information, including personal data, the
                      Parties may redact part of the text of the Appendix prior
                      to sharing a copy, but shall provide a meaningful summary
                      where the data subject would otherwise not be able to
                      understand its content or exercise his/her rights. On
                      request, the Parties shall provide the data subject with
                      the reasons for the redactions, to the extent possible
                      without revealing the redacted information.
                    </li>
                    <li className="mb-4">
                      <strong>(d)</strong> Paragraphs (a) to (c) are without
                      prejudice to the obligations of the data exporter under
                      Articles 13 and 14 of Regulation (EU) 2016/679.
                    </li>
                  </ul>
                </div>
                <h6 className="mb-4">8.3 Accuracy and data minimisation</h6>
                <div className="mb-4">
                  <ul>
                    <li className="mb-4">
                      <strong>(a)</strong> Each Party shall ensure that the
                      personal data is accurate and, where necessary, kept up to
                      date. The data importer shall take every reasonable step
                      to ensure that personal data that is inaccurate, having
                      regard to the purpose(s) of processing, is erased or
                      rectified without delay.
                    </li>
                    <li className="mb-4">
                      <strong>(b)</strong> If one of the Parties becomes aware
                      that the personal data it has transferred or received is
                      inaccurate, or has become outdated, it shall inform the
                      other Party without undue delay.
                    </li>
                    <li className="mb-4">
                      <strong>(c)</strong> The data importer shall ensure that
                      the personal data is adequate, relevant and limited to
                      what is necessary in relation to the purpose(s) of
                      processing.
                    </li>
                  </ul>
                </div>
                <h6 className="mb-4">8.4 Storage limitation</h6>
                <p className="mb-4">
                  The data importer shall retain the personal data for no longer
                  than necessary for the purpose(s) for which it is processed.
                  It shall put in place appropriate technical or organisational
                  measures to ensure compliance with this obligation, including
                  erasure or anonymization of the data and all back-ups at the
                  end of the retention period.
                </p>
                <h6 className="mb-4">8.5 Security of processing</h6>
                <div className="mb-4">
                  <ul>
                    <li className="mb-4">
                      <strong>(a)</strong> The data importer and, during
                      transmission, also the data exporter shall implement
                      appropriate technical and organisational measures to
                      ensure the security of the personal data, including
                      protection against a breach of security leading to
                      accidental or unlawful destruction, loss, alteration,
                      unauthorised disclosure or access (hereinafter 'personal
                      data breach'). In assessing the appropriate level of
                      security, they shall take due account of the state of the
                      art, the costs of implementation, the nature, scope,
                      context and purpose(s) of processing and the risks
                      involved in the processing for the data subject. The
                      Parties shall in particular consider having recourse to
                      encryption or pseudonymisation, including during
                      transmission, where the purpose of processing can be
                      fulfilled in that manner.
                    </li>
                    <li className="mb-4">
                      <strong>(b)</strong> The Parties have agreed on the
                      technical and organisational measures set out in Annex II.
                      The data importer shall carry out regular checks to ensure
                      that these measures continue to provide an appropriate
                      level of security.
                    </li>
                    <li className="mb-4">
                      <strong>(c)</strong> The data importer shall ensure that
                      persons authorised to process the personal data have
                      committed themselves to confidentiality or are under an
                      appropriate statutory obligation of confidentiality.
                    </li>
                    <li className="mb-4">
                      <strong>(d)</strong> In the event of a personal data
                      breach concerning personal data processed by the data
                      importer under these Clauses, the data importer shall take
                      appropriate measures to address the personal data breach,
                      including measures to mitigate its possible adverse
                      effects.
                    </li>
                    <li className="mb-4">
                      <strong>(e)</strong> In case of a personal data breach
                      that is likely to result in a risk to the rights and
                      freedoms of natural persons, the data importer shall
                      without undue delay notify both the data exporter and the
                      competent supervisory authority pursuant to Clause 13.
                      Such notification shall contain i) a description of the
                      nature of the breach (including, where possible,
                      categories and approximate number of data subjects and
                      personal data records concerned), ii) its likely
                      consequences, iii) the measures taken or proposed to
                      address the breach, and iv) the details of a contact point
                      from whom more information can be obtained. To the extent
                      it is not possible for the data importer to provide all
                      the information at the same time, it may do so in phases
                      without undue further delay.
                    </li>
                    <li className="mb-4">
                      <strong>(f)</strong> In case of a personal data breach
                      that is likely to result in a high risk to the rights and
                      freedoms of natural persons, the data importer shall also
                      notify without undue delay the data subjects concerned of
                      the personal data breach and its nature, if necessary in
                      cooperation with the data exporter, together with the
                      information referred to in paragraph (e), points ii) to
                      iv), unless the data importer has implemented measures to
                      significantly reduce the risk to the rights or freedoms of
                      natural persons, or notification would involve
                      disproportionate efforts. In the latter case, the data
                      importer shall instead issue a public communication or
                      take a similar measure to inform the public of the
                      personal data breach.
                    </li>
                    <li className="mb-4">
                      <strong>(g)</strong> The data importer shall document all
                      relevant facts relating to the personal data breach,
                      including its effects and any remedial action taken, and
                      keep a record thereof.
                    </li>
                  </ul>
                </div>
                <h6 className="mb-4">8.6 Sensitive data</h6>
                <p className="mb-4">
                  Where the transfer involves personal data revealing racial or
                  ethnic origin, political opinions, religious or philosophical
                  beliefs, or trade union membership, genetic data, or biometric
                  data for the purpose of uniquely identifying a natural person,
                  data concerning health or a person's sex life or sexual
                  orientation, or data relating to criminal convictions or
                  offences (hereinafter 'sensitive data'), the data importer
                  shall apply specific restrictions and/or additional safeguards
                  adapted to the specific nature of the data and the risks
                  involved. This may include restricting the personnel permitted
                  to access the personal data, additional security measures
                  (such as pseudonymisation) and/or additional restrictions with
                  respect to further disclosure.
                </p>
                <h6 className="mb-4">8.7 Onward transfers</h6>
                <p className="mb-4">
                  The data importer shall not disclose the personal data to a
                  third party located outside the European Union (in the same
                  country as the data importer or in another third country,
                  hereinafter 'onward transfer') unless the third party is or
                  agrees to be bound by these Clauses, under the appropriate
                  Module. Otherwise, an onward transfer by the data importer may
                  only take place if:
                  <ul className="ms-4 my-3">
                    <li className="mb-4">
                      <strong>(i)</strong> it is to a country benefitting from
                      an adequacy decision pursuant to Article 45 of Regulation
                      (EU) 2016/679 that covers the onward transfer;
                    </li>
                    <li className="mb-4">
                      <strong>(ii)</strong> the third party otherwise ensures
                      appropriate safeguards pursuant to Articles 46 or 47 of
                      Regulation (EU) 2016/679 with respect to the processing in
                      question;
                    </li>
                    <li className="mb-4">
                      <strong>(iii)</strong> the third party enters into a
                      binding instrument with the data importer ensuring the
                      same level of data protection as under these Clauses, and
                      the data importer provides a copy of these safeguards to
                      the data exporter;
                    </li>
                    <li className="mb-4">
                      <strong>(iv)</strong> it is necessary for the
                      establishment, exercise or defence of legal claims in the
                      context of specific administrative, regulatory or judicial
                      proceedings;
                    </li>
                    <li className="mb-4">
                      <strong>(v)</strong> it is necessary in order to protect
                      the vital interests of the data subject or of another
                      natural person; or
                    </li>
                    <li className="mb-4">
                      <strong>(vi)</strong> where none of the other conditions
                      apply, the data importer has obtained the explicit consent
                      of the data subject for an onward transfer in a specific
                      situation, after having informed him/her of its
                      purpose(s), the identity of the recipient and the possible
                      risks of such transfer to him/her due to the lack of
                      appropriate data protection safeguards. In this case, the
                      data importer shall inform the data exporter and, at the
                      request of the latter, shall transmit to it a copy of the
                      information provided to the data subject.
                      <br />
                      <br />
                      <span>
                        Any onward transfer is subject to compliance by the data
                        importer with all the other safeguards under these
                        Clauses, in particular purpose limitation.
                      </span>
                    </li>
                  </ul>
                </p>
                <h6 className="mb-4">
                  8.8 Processing under the authority of the data importer
                </h6>
                <p className="mb-4">
                  The data importer shall ensure that any person acting under
                  its authority, including a processor, processes the data only
                  on its instructions.
                </p>
                <h6 className="mb-4">8.9 Documentation and compliance</h6>
                <p className="mb-4">
                  <ul>
                    <li className="mb-4">
                      <strong>(a)</strong> Each Party shall be able to
                      demonstrate compliance with its obligations under these
                      Clauses. In particular, the data importer shall keep
                      appropriate documentation of the processing activities
                      carried out under its responsibility.
                    </li>
                    <li className="mb-4">
                      <strong>(b)</strong> The data importer shall make such
                      documentation available to the competent supervisory
                      authority on request.
                    </li>
                  </ul>
                </p>
              </div>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 9</h5>
                <h6 className="mb-4">Use of sub-processors</h6>
                <p className="mb-4">N/A</p>
              </div>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 10</h5>
                <h6 className="mb-4">Data subject rights</h6>
                <div className="mb-4">
                  <ul>
                    <li className="mb-4">
                      <strong>(a)</strong> The data importer, where relevant
                      with the assistance of the data exporter, shall deal with
                      any enquiries and requests it receives from a data subject
                      relating to the processing of his/her personal data and
                      the exercise of his/her rights under these Clauses without
                      undue delay and at the latest within one month of the
                      receipt of the enquiry or request. The data importer shall
                      take appropriate measures to facilitate such enquiries,
                      requests and the exercise of data subject rights. Any
                      information provided to the data subject shall be in an
                      intelligible and easily accessible form, using clear and
                      plain language.
                    </li>
                    <li className="mb-4">
                      <p>
                        <strong>(b)</strong> In particular, upon request by the
                        data subject the data importer shall, free of charge:
                      </p>
                      <ul className="ms-4 my-3">
                        <li className="mb-4">
                          <strong>(i)</strong> provide confirmation to the data
                          subject as to whether personal data concerning him/her
                          is being processed and, where this is the case, a copy
                          of the data relating to him/her and the information in
                          Annex I; if personal data has been or will be onward
                          transferred, provide information on recipients or
                          categories of recipients (as appropriate with a view
                          to providing meaningful information) to which the
                          personal data has been or will be onward transferred,
                          the purpose of such onward transfers and their ground
                          pursuant to Clause 8.7; and provide information on the
                          right to lodge a complaint with a supervisory
                          authority in accordance with Clause 12(c)(i);
                        </li>
                        <li className="mb-4">
                          <strong>(ii)</strong> rectify inaccurate or incomplete
                          data concerning the data subject;
                        </li>
                        <li className="mb-4">
                          <strong>(iii)</strong> erase personal data concerning
                          the data subject if such data is being or has been
                          processed in violation of any of these Clauses
                          ensuring third-party beneficiary rights, or if the
                          data subject withdraws the consent on which the
                          processing is based.
                        </li>
                      </ul>
                    </li>
                    <li className="mb-4">
                      <strong>(c)</strong> Where the data importer processes the
                      personal data for direct marketing purposes, it shall
                      cease processing for such purposes if the data subject
                      objects to it.
                    </li>
                    <li className="mb-4">
                      <p>
                        <strong>(d)</strong> Where the data importer processes
                        the personal data for direct marketing purposes, it
                        shall cease processing for such purposes if the data
                        subject objects to it.
                      </p>
                      <ul className="ms-4 my-3">
                        <li className="mb-4">
                          <strong>(i)</strong> inform the data subject about the
                          envisaged automated decision, the envisaged
                          consequences and the logic involved; and
                        </li>
                        <li className="mb-4">
                          <strong>(ii)</strong> implement suitable safeguards,
                          at least by enabling the data subject to contest the
                          decision, express his/her point of view and obtain
                          review by a human being.
                        </li>
                      </ul>
                    </li>
                    <li className="mb-4">
                      <strong>(e)</strong> Where requests from a data subject
                      are excessive, in particular because of their repetitive
                      character, the data importer may either charge a
                      reasonable fee taking into account the administrative
                      costs of granting the request or refuse to act on the
                      request.
                    </li>
                    <li className="mb-4">
                      <strong>(f)</strong> The data importer may refuse a data
                      subject's request if such refusal is allowed under the
                      laws of the country of destination and is necessary and
                      proportionate in a democratic society to protect one of
                      the objectives listed in Article 23(1) of Regulation (EU)
                      2016/679.
                    </li>
                    <li className="mb-4">
                      <strong>(g)</strong> If the data importer intends to
                      refuse a data subject's request, it shall inform the data
                      subject of the reasons for the refusal and the possibility
                      of lodging a complaint with the competent supervisory
                      authority and/or seeking judicial redress.
                    </li>
                  </ul>
                </div>
              </div>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 11</h5>
                <h6 className="mb-4">Redress</h6>
                <div className="mb-4">
                  <ul>
                    <li className="mb-4">
                      <strong>(a)</strong> The data importer shall inform data
                      subjects in a transparent and easily accessible format,
                      through individual notice or on its website, of a contact
                      point authorised to handle complaints. It shall deal
                      promptly with any complaints it receives from a data
                      subject.
                    </li>
                    <li className="mb-4">
                      <strong>(b)</strong> In case of a dispute between a data
                      subject and one of the Parties as regards compliance with
                      these Clauses, that Party shall use its best efforts to
                      resolve the issue amicably in a timely fashion. The
                      Parties shall keep each other informed about such disputes
                      and, where appropriate, cooperate in resolving them.
                    </li>
                    <li className="mb-4">
                      <strong>(c)</strong> Where the data subject invokes a
                      third-party beneficiary right pursuant to Clause 3, the
                      data importer shall accept the decision of the data
                      subject to:
                      <ul className="ms-4 my-3">
                        <li className="mb-4">
                          <strong>(i)</strong> lodge a complaint with the
                          supervisory authority in the Member State of his/her
                          habitual residence or place of work, or the competent
                          supervisory authority pursuant to Clause 13;
                        </li>
                        <li className="mb-4">
                          <strong>(ii)</strong> refer the dispute to the
                          competent courts within the meaning of Clause 18.
                        </li>
                      </ul>
                    </li>
                    <li className="mb-4">
                      <strong>(d)</strong> The Parties accept that the data
                      subject may be represented by a not-for-profit body,
                      organisation or association under the conditions set out
                      in Article 80(1) of Regulation (EU) 2016/679.
                    </li>
                    <li className="mb-4">
                      <strong>(e)</strong> The data importer shall abide by a
                      decision that is binding under the applicable EU or Member
                      State law.
                    </li>
                    <li className="mb-4">
                      <strong>(f)</strong> The data importer agrees that the
                      choice made by the data subject will not prejudice his/her
                      substantive
                    </li>
                  </ul>
                </div>
              </div>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 12</h5>
                <h6 className="mb-4">Liability</h6>
                <div className="mb-4">
                  <ul>
                    <li className="mb-4">
                      <strong>(a)</strong> Each Party shall be liable to the
                      other Party/ies for any damages it causes the other
                      Party/ies by any breach of these Clauses.
                    </li>
                    <li className="mb-4">
                      <strong>(b)</strong> Each Party shall be liable to the
                      data subject, and the data subject shall be entitled to
                      receive compensation, for any material or non-material
                      damages that the Party causes the data subject by
                      breaching the third-party beneficiary rights under these
                      Clauses. This is without prejudice to the liability of the
                      data exporter under Regulation (EU) 2016/679.
                    </li>
                    <li className="mb-4">
                      <strong>(c)</strong> Where more than one Party is
                      responsible for any damage caused to the data subject as a
                      result of a breach of these Clauses, all responsible
                      Parties shall be jointly and severally liable and the data
                      subject is entitled to bring an action in court against
                      any of these Parties.
                    </li>
                    <li className="mb-4">
                      <strong>(d)</strong> The Parties agree that if one Party
                      is held liable under paragraph (c), it shall be entitled
                      to claim back from the other Party/ies that part of the
                      compensation corresponding to its/their responsibility for
                      the damage.
                    </li>
                    <li className="mb-4">
                      <strong>(e)</strong> The data importer may not invoke the
                      conduct of a processor or sub-processor to avoid its own
                      liability.
                    </li>
                  </ul>
                </div>
              </div>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 13</h5>
                <h6 className="mb-4">Supervision</h6>
                <div className="mb-4">
                  <ul>
                    <li className="mb-4">
                      <strong>(a)</strong> The supervisory authority with
                      responsibility for ensuring compliance by the data
                      exporter with Regulation (EU) 2016/679 as regards the data
                      transfer, as indicated in Annex I.C, shall act as
                      competent supervisory authority.
                    </li>
                    <li className="mb-4">
                      <strong>(b)</strong> The data importer agrees to submit
                      itself to the jurisdiction of and cooperate with the
                      competent supervisory authority in any procedures aimed at
                      ensuring compliance with these Clauses. In particular, the
                      data importer agrees to respond to enquiries, submit to
                      audits and comply with the measures adopted by the
                      supervisory authority, including remedial and compensatory
                      measures. It shall provide the supervisory authority with
                      written confirmation that the necessary actions have been
                      taken.
                    </li>
                  </ul>
                </div>
              </div>
            </section>
            <section className="mb-4">
              <h5 className="mb-2 text-center">
                SECTION III – LOCAL LAWS AND OBLIGATIONS IN CASE OF ACCESS BY
                PUBLIC AUTHORITIES
              </h5>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 14</h5>
                <h6 className="mb-4">
                  Local laws and practices affecting compliance with the Clauses
                </h6>
                <div className="mb-4">
                  <ul>
                    <li className="mb-4">
                      <strong>(a)</strong> The Parties warrant that they have no
                      reason to believe that the laws and practices in the third
                      country of destination applicable to the processing of the
                      personal data by the data importer, including any
                      requirements to disclose personal data or measures
                      authorising access by public authorities, prevent the data
                      importer from fulfilling its obligations under these
                      Clauses. This is based on the understanding that laws and
                      practices that respect the essence of the fundamental
                      rights and freedoms and do not exceed what is necessary
                      and proportionate in a democratic society to safeguard one
                      of the objectives listed in Article 23(1) of Regulation
                      (EU) 2016/679, are not in contradiction with these
                      Clauses.
                    </li>
                    <li className="mb-4">
                      <strong>(b)</strong> The Parties declare that in providing
                      the warranty in paragraph (a), they have taken due account
                      in particular of the following elements:
                      <ul className="ms-4 my-3">
                        <li className="mb-4">
                          <strong>(i)</strong> the specific circumstances of the
                          transfer, including the length of the processing
                          chain, the number of actors involved and the
                          transmission channels used; intended onward transfers;
                          the type of recipient; the purpose of processing; the
                          categories and format of the transferred personal
                          data; the economic sector in which the transfer
                          occurs; the storage location of the data transferred;
                        </li>
                        <li className="mb-4">
                          <strong>(ii)</strong> the laws and practices of the
                          third country of destination– including those
                          requiring the disclosure of data to public authorities
                          or authorising access by such authorities – relevant
                          in light of the specific circumstances of the
                          transfer, and the applicable limitations and
                          safeguards;
                        </li>
                        <li className="mb-4">
                          <strong>(iii)</strong> any relevant contractual,
                          technical or organisational safeguards put in place to
                          supplement the safeguards under these Clauses,
                          including measures applied during transmission and to
                          the processing of the personal data in the country of
                          destination.
                        </li>
                      </ul>
                    </li>
                    <li className="mb-4">
                      <strong>(c)</strong> The data importer warrants that, in
                      carrying out the assessment under paragraph (b), it has
                      made its best efforts to provide the data exporter with
                      relevant information and agrees that it will continue to
                      cooperate with the data exporter in ensuring compliance
                      with these Clauses.
                    </li>
                    <li className="mb-4">
                      <strong>(d)</strong> The Parties agree to document the
                      assessment under paragraph (b) and make it available to
                      the competent supervisory authority on request.
                    </li>
                    <li className="mb-4">
                      <strong>(e)</strong> The data importer agrees to notify
                      the data exporter promptly if, after having agreed to
                      these Clauses and for the duration of the contract, it has
                      reason to believe that it is or has become subject to laws
                      or practices not in line with the requirements under
                      paragraph (a), including following a change in the laws of
                      the third country or a measure (such as a disclosure
                      request) indicating an application of such laws in
                      practice that is not in line with the requirements in
                      paragraph (a).
                    </li>
                    <li className="mb-4">
                      <strong>(f)</strong> Following a notification pursuant to
                      paragraph (e), or if the data exporter otherwise has
                      reason to believe that the data importer can no longer
                      fulfil its obligations under these Clauses, the data
                      exporter shall promptly identify appropriate measures
                      (e.g. technical or organisational measures to ensure
                      security and confidentiality) to be adopted by the data
                      exporter and/or data importer to address the situation.
                      The data exporter shall suspend the data transfer if it
                      considers that no appropriate safeguards for such transfer
                      can be ensured, or if instructed by the competent
                      supervisory authority to do so. In this case, the data
                      exporter shall be entitled to terminate the contract,
                      insofar as it concerns the processing of personal data
                      under these Clauses. If the contract involves more than
                      two Parties, the data exporter may exercise this right to
                      termination only with respect to the relevant Party,
                      unless the Parties have agreed otherwise. Where the
                      contract is terminated pursuant to this Clause, Clause
                      16(d) and (e) shall apply.
                    </li>
                  </ul>
                </div>
              </div>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 15</h5>
                <h6 className="mb-4">
                  Obligations of the data importer in case of access by public
                  authorities
                </h6>
                <h6 className="mb-4">15.1 Notification</h6>
                <div className="mb-4">
                  <ul>
                    <li className="mb-4">
                      <strong>(a)</strong> The data importer agrees to notify
                      the data exporter and, where possible, the data subject
                      promptly (if necessary with the help of the data exporter)
                      if it:
                      <ul className="ms-4 my-3">
                        <li className="mb-4">
                          <strong>(i)</strong> receives a legally binding
                          request from a public authority, including judicial
                          authorities, under the laws of the country of
                          destination for the disclosure of personal data
                          transferred pursuant to these Clauses; such
                          notification shall include information about the
                          personal data requested, the requesting authority, the
                          legal basis for the request and the response provided;
                          or
                        </li>
                        <li className="mb-4">
                          <strong>(ii)</strong> becomes aware of any direct
                          access by public authorities to personal data
                          transferred pursuant to these Clauses in accordance
                          with the laws of the country of destination; such
                          notification shall include all information available
                          to the importer.
                        </li>
                      </ul>
                    </li>
                    <li className="mb-4">
                      <strong>(b)</strong> If the data importer is prohibited
                      from notifying the data exporter and/or the data subject
                      under the laws of the country of destination, the data
                      importer agrees to use its best efforts to obtain a waiver
                      of the prohibition, with a view to communicating as much
                      information as possible, as soon as possible. The data
                      importer agrees to document its best efforts in order to
                      be able to demonstrate them on request of the data
                      exporter.
                    </li>
                    <li className="mb-4">
                      <strong>(c)</strong> Where permissible under the laws of
                      the country of destination, the data importer agrees to
                      provide the data exporter, at regular intervals for the
                      duration of the contract, with as much relevant
                      information as possible on the requests received (in
                      particular, number of requests, type of data requested,
                      requesting authority/ies, whether requests have been
                      challenged and the outcome of such challenges, etc.).
                    </li>
                    <li className="mb-4">
                      <strong>(d)</strong> The data importer agrees to preserve
                      the information pursuant to paragraphs (a) to (c) for the
                      duration of the contract and make it available to the
                      competent supervisory authority on request.
                    </li>
                    <li className="mb-4">
                      <strong>(e)</strong> Paragraphs (a) to (c) are without
                      prejudice to the obligation of the data importer pursuant
                      to Clause 14(e) and Clause 16 to inform the data exporter
                      promptly where it is unable to comply with these Clauses.
                    </li>
                  </ul>
                </div>
                <h6 className="mb-4">
                  15.2 Review of legality and data minimisation
                </h6>
                <div className="mb-4">
                  <ul>
                    <li className="mb-4">
                      <strong>(a)</strong> The data importer agrees to review
                      the legality of the request for disclosure, in particular
                      whether it remains within the powers granted to the
                      requesting public authority, and to challenge the request
                      if, after careful assessment, it concludes that there are
                      reasonable grounds to consider that the request is
                      unlawful under the laws of the country of destination,
                      applicable obligations under international law and
                      principles of international comity. The data importer
                      shall, under the same conditions, pursue possibilities of
                      appeal. When challenging a request, the data importer
                      shall seek interim measures with a view to suspending the
                      effects of the request until the competent judicial
                      authority has decided on its merits. It shall not disclose
                      the personal data requested until required to do so under
                      the applicable procedural rules. These requirements are
                      without prejudice to the obligations of the data importer
                      under Clause 14(e).
                    </li>
                    <li className="mb-4">
                      <strong>(b)</strong> The data importer agrees to document
                      its legal assessment and any challenge to the request for
                      disclosure and, to the extent permissible under the laws
                      of the country of destination, make the documentation
                      available to the data exporter. It shall also make it
                      available to the competent supervisory authority on
                      request.
                    </li>
                    <li className="mb-4">
                      <strong>(c)</strong> The data importer agrees to provide
                      the minimum amount of information permissible when
                      responding to a request for disclosure, based on a
                      reasonable interpretation of the request.
                    </li>
                  </ul>
                </div>
              </div>
            </section>
            <section className="mb-4">
              <h5 className="mb-2 text-center">
                SECTION IV – FINAL PROVISIONS
              </h5>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 16</h5>
                <h6 className="mb-4">
                  Non-compliance with the Clauses and termination
                </h6>
                <div className="mb-4">
                  <ul>
                    <li className="mb-4">
                      <strong>(a)</strong> The data importer shall promptly
                      inform the data exporter if it is unable to comply with
                      these Clauses, for whatever reason.
                    </li>
                    <li className="mb-4">
                      <strong>(b)</strong> In the event that the data importer
                      is in breach of these Clauses or unable to comply with
                      these Clauses, the data exporter shall suspend the
                      transfer of personal data to the data importer until
                      compliance is again ensured or the contract is terminated.
                      This is without prejudice to Clause 14(f).
                    </li>
                    <li className="mb-4">
                      <strong>(c)</strong> The data exporter shall be entitled
                      to terminate the contract, insofar as it concerns the
                      processing of personal data under these Clauses, where:
                      <ul className="ms-4 my-3">
                        <li className="mb-4">
                          <strong>(i)</strong> the data exporter has suspended
                          the transfer of personal data to the data importer
                          pursuant to paragraph (b) and compliance with these
                          Clauses is not restored within a reasonable time and
                          in any event within one month of suspension;
                        </li>
                        <li className="mb-4">
                          <strong>(ii)</strong> the data importer is in
                          substantial or persistent breach of these Clauses; or
                        </li>
                        <li className="mb-4">
                          <strong>(iii)</strong> the data importer fails to
                          comply with a binding decision of a competent court or
                          supervisory authority regarding its obligations under
                          these Clauses.
                        </li>
                      </ul>
                      In these cases, it shall inform the competent supervisory
                      authority of such non-compliance. Where the contract
                      involves more than two Parties, the data exporter may
                      exercise this right to termination only with respect to
                      the relevant Party, unless the Parties have agreed
                      otherwise.
                    </li>
                    <li className="mb-4">
                      <strong>(d)</strong> Personal data that has been
                      transferred prior to the termination of the contract
                      pursuant to paragraph (c) shall at the choice of the data
                      exporter immediately be returned to the data exporter or
                      deleted in its entirety. The same shall apply to any
                      copies of the data. The data importer shall certify the
                      deletion of the data to the data exporter. Until the data
                      is deleted or returned, the data importer shall continue
                      to ensure compliance with these Clauses. In case of local
                      laws applicable to the data importer that prohibit the
                      return or deletion of the transferred personal data, the
                      data importer warrants that it will continue to ensure
                      compliance with these Clauses and will only process the
                      data to the extent and for as long as required under that
                      local law.
                    </li>
                    <li className="mb-4">
                      <strong>(e)</strong> Either Party may revoke its agreement
                      to be bound by these Clauses where (i) the European
                      Commission adopts a decision pursuant to Article 45(3) of
                      Regulation (EU) 2016/679 that covers the transfer of
                      personal data to which these Clauses apply; or (ii)
                      Regulation (EU) 2016/679 becomes part of the legal
                      framework of the country to which the personal data is
                      transferred. This is without prejudice to other
                      obligations applying to the processing in question under
                      Regulation (EU) 2016/679.
                    </li>
                  </ul>
                </div>
              </div>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 17</h5>
                <h6 className="mb-4">Governing law</h6>
                <p className="mb-4">
                  These Clauses shall be governed by the law of one of the EU
                  Member States, provided such law allows for third-party
                  beneficiary rights. The Parties agree that this shall be the
                  law of Belgium.
                </p>
              </div>
              <div className={`${styles.clauseBlock} mb-4`}>
                <h5 className="text-center mb-4">CLAUSE 18</h5>
                <h6 className="mb-4">Choice of forum and jurisdiction</h6>
                <div className="mb-4">
                  <ul>
                    <li className="mb-4">
                      <strong>(a)</strong> Any dispute arising from these
                      Clauses shall be resolved by the courts of an EU Member
                      State.
                    </li>
                    <li className="mb-4">
                      <strong>(b)</strong> The Parties agree that those shall be
                      the courts of Belgium.
                    </li>
                    <li className="mb-4">
                      <strong>(c)</strong> A data subject may also bring legal
                      proceedings against the data exporter and/or data importer
                      before the courts of the Member State in which he/she has
                      his/her habitual residence.
                    </li>
                    <li className="mb-4">
                      <strong>(d)</strong> The Parties agree to submit
                      themselves to the jurisdiction of such courts.
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </div>
          <div className={`${styles.annexBlock} ${styles.annex1}`}>
            <div className={`${styles.annexBlockAHeader}`}>ANNEX I</div>
            <section>
              <div className={`${styles.annexBlockAHeader} text-start`}>
                A. LIST OF PARTIES
              </div>
              <div className="ms-5">
                <p className="mb-4">
                  <strong>Data exporter(s):</strong> [Identity and contact
                  details of the data exporter(s) and, where applicable, of
                  its/their data protection officer and/or representative in the
                  European Union]
                </p>
                <p className="mb-4 ms-5">
                  <span className="mb-4 d-block">
                    As detailed in Agreement.
                  </span>
                  Role: Controller
                </p>
                <p className="mb-4">
                  <strong>Data importer(s):</strong>
                </p>
                <div className="mb-4 ms-5">
                  <p className="mb-3">
                    1. Name: Project Management Institute, Inc.
                  </p>
                  <p className="mb-3">
                    Address: 18 Campus Boulevard, Suite 150, Newtown Square PA
                    19073
                  </p>
                  <p className="mb-3">
                    Contact person's name, position and contact details: Leah
                    Brophy, Privacy Contact,{' '}
                    <a href="mailto: privacy@pmi.org">privacy@pmi.org</a>
                  </p>
                  <p className="mb-3">Role: Controller</p>
                </div>
              </div>
            </section>
            <section>
              <div className={`${styles.annexBlockAHeader} text-start`}>
                B. DESCRIPTION OF TRANSFER
              </div>
              <div className="mb-4 ms-5">
                <p className="mb-3">
                  Categories of data subjects whose personal data is transferred
                </p>
                <p className="mb-3">Users as defined in the Agreement.</p>
                <p className="mb-3">Categories of personal data transferred</p>
                <p className="mb-3">Full name, email address</p>
                <p className="mb-3">The frequency of the transfer).</p>
                <p className="mb-3">Continuous</p>
                <p className="mb-3">
                  Purpose(s) of the data transfer and further processing
                </p>
                <p className="mb-3">
                  Fulfill the Customer’s purchase; as detailed in the Agreement.
                </p>
              </div>
            </section>
            <section>
              <div className={`${styles.annexBlockAHeader} text-start`}>
                C. COMPETENT SUPERVISORY AUTHORITY
              </div>
              <div className="mb-4 ms-5">
                <p>
                  Belgium - Autorité de la protection des données –
                  Gegevensbeschermingsautoriteit (APD-GBA)
                </p>
              </div>
            </section>
          </div>
          <div className={styles.annexBlock}>
            <div className={`${styles.annexBlockAHeader}`}>ANNEX II</div>
            <div className={`${styles.annexBlockAHeader}`}>
              TECHNICAL AND ORGANISATIONAL MEASURES INCLUDING TECHNICAL AND
              ORGANISATIONAL MEASURES TO ENSURE THE SECURITY OF THE DATA
            </div>
            <p className="mb-3">
              PMI’s Information Security Program is aligned with ISO 27001
              standards and is comprised of a robust set of policies and
              controls to manage and mitigate the risks associated with storing,
              processing, and transmitting personal data. PMI’s Information
              Security Program also includes selected NIST and CIS
              recommendations that fit our risk appetite. PMI maintains a
              controlled and secure environment and protects the integrity,
              confidentiality, and availability of data in accordance with
              applicable best practices, laws, regulations, and business
              requirements. PMI’s security program includes a two-year strategy
              linked to the organization’s technology services roadmap. The Head
              of Security provides regular reports to senior leadership and the
              Board of Directors.
            </p>
            <p>Key elements of the Information Security Program include:</p>
            <ul className="py-3">
              <li className="mb-4">
                <p>
                  <strong>1. Policies, Procedures, and Standards</strong>
                  Security policies, procedures, and standards are reviewed,
                  updated, and communicated on an annual basis, which include
                  acceptable use, asset management, access control, logging and
                  monitoring, password management, patch management,
                  vulnerability management, system hardening, and security
                  awareness.
                </p>
              </li>
              <li className="mb-4">
                <p>
                  <strong>2. Risk Management</strong>
                  Enterprise risks and security risks are evaluated on a
                  recurring basis to identify and assess potential risks to the
                  IT infrastructure, both internal and external, and to evaluate
                  the sensitivity and criticality of data collected, stored, and
                  processed.
                </p>
              </li>
              <li className="mb-4">
                <p>
                  <strong>3. Infrastructure Security</strong>
                  PMI servers and applications are primarily hosted with
                  Microsoft Azure, leveraging cloud-based security capabilities
                  managed by Microsoft. Firewalls and intrusion
                  detection/prevention systems are in place to protect both
                  cloud and physical networks, web applications are protected
                  against distributed denial-of-service (DDoS) and other related
                  attacks, and network segmentation restricts access to
                  sensitive areas of the infrastructure.
                </p>
              </li>
              <li className="mb-4">
                <p>
                  <strong>4. Asset Management</strong>
                  Hardware and software assets are inventoried, monitored,
                  managed, and tracked on a recurring basis. Industry standard
                  mobile device management (MDM) and advanced threat protection
                  (ATP) tools handle security control enforcement, allow remote
                  management, and apply patches for PMI-owned devices.
                </p>
              </li>
              <li className="mb-4">
                <p>
                  <strong>5. Change Management</strong>
                  System and application changes are governed by the Change
                  Advisory Board (CAB). Change requests are tracked via a
                  ticketing system and reviewed by the CAB weekly.
                </p>
              </li>
              <li className="mb-4">
                <p>
                  <strong>6. Access Control</strong>
                  Strong access controls are in place to limit access to
                  critical resources and identify and prevent unauthorized
                  access. Multi-factor authentication (MFA) is required for all
                  users, access is regularly reviewed, and access privileges are
                  granted based on job roles and responsibilities. Privileged
                  identity management (PIM) controls access to highly privileged
                  roles and maintains an audit trail of their activation and
                  use.
                </p>
              </li>
              <li className="mb-4">
                <p>
                  <strong>7. Encryption</strong>
                  Encryption is used both in transit and at rest to protect
                  against unauthorized access to confidential and/or proprietary
                  information and personal data. Encryption keys are stored
                  securely and rotated regularly or after suspected compromise.
                </p>
              </li>
              <li className="mb-4">
                <p>
                  <strong>8. Logging and Monitoring</strong>
                  Continuous monitoring is in place to detect and respond to
                  suspicious activities, supported by a 24x7x365 security
                  operations center (SOC), security incident and event
                  management (SIEM) solution, and extended detection and
                  response (XDR) for endpoints and cloud applications. Security
                  alerts are investigated promptly, and escalation procedures
                  are documented and followed.
                </p>
              </li>
              <li className="mb-4">
                <p>
                  <strong>9.Physical Security</strong>
                  PMI’s IT infrastructure is primarily cloud-based, and
                  employees are remote; however, PMI’s office headquarters is
                  protected with proximity card readers, restricted access to
                  protected areas including the IT room and fulfillment room,
                  CCTV video surveillance, and burglar alarm system. Visitors
                  must be escorted when onsite.
                </p>
              </li>
              <li className="mb-4">
                <p>
                  <strong>10. Training and Awareness</strong>
                  Security awareness training is required for all employees upon
                  hire and annually. Email phishing campaigns are conducted
                  regularly, and employees who fail the phishing exercises
                  receive additional training. Role-based training is required
                  for specific roles including software developers and customer
                  care representatives.
                </p>
              </li>
              <li className="mb-4">
                <p>
                  <strong>11. Third-Party Risk Management</strong>
                  Security practices for third-party service providers are
                  assessed as part of the vendor procurement process and are
                  reassessed annually. Service-level agreements (SLAs) include
                  security requirements expected of third-party service
                  providers.
                </p>
              </li>
              <li className="mb-4">
                <p>
                  <strong>12. Incident Response</strong>
                  An incident response plan is in place that outlines steps to
                  be taken in case of a security incident, including
                  identification, protection, detection, response, and recovery
                  efforts. The incident response plan is tested and updated
                  annually.
                </p>
              </li>
              <li className="mb-4">
                <p>
                  <strong>13. Business Continuity and Disaster Recovery</strong>
                  Business continuity and disaster recovery plans are updated
                  and tested annually or after significant changes occur to the
                  business. System and data backups are performed frequently
                  according to PMI’s backup policy.
                </p>
              </li>
              <li className="mb-4">
                <p>
                  <strong>14. Security Program Auditing and Assessment</strong>
                  Security audits are performed throughout the year that include
                  monthly vulnerability scanning, annual penetration testing,
                  general controls reviews, and maturity assessments. Security
                  gaps are prioritized and remediated using a risk-based
                  approach. Vulnerability scan results are reviewed monthly, and
                  PMI seeks to remediate critical and high findings within 30
                  days.
                </p>
              </li>
              <li className="mb-4">
                <p className="d-block mb-3">
                  <strong>
                    15. Compliance with Legal and Data Governance Requirements{' '}
                  </strong>
                  PMI maintains compliance with relevant data protection laws
                  and industry regulations. PMI actively monitors for changes in
                  regulations that may impact the Information Security Program.
                  PMI’s Privacy Policy, maintained by the PMI Legal Team,
                  governs how the company collects and uses personal data. This
                  policy applies to anyone who chooses to use PMI services:{' '}
                  <a href="https://www.pmi.org/privacy" target="_new">
                    https://www.pmi.org/privacy
                  </a>
                </p>
                <p>
                  PMI’s Data Governance Program identifies and assigns data
                  stewards to be accountable for the data used by their business
                  and operational areas. The Data Governance Program, in
                  conjunction with the PMI Legal Team, implements policies and
                  controls that guide PMI on balancing data use in accordance
                  with applicable laws and regulations in the areas of data
                  retention, minimization, quality, portability, and erasure.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
